import React from 'react';
import AddProjectPricingCreateWindowDescription from '../Contents/Operations/Projects/AddProjectPricingCreateWindowDescription';
import ClientFeeItem from '../Domain/ClientFeeItem';
import ProjectPricingItem from '../Domain/ProjectPricingItem';
import CrudTypesEnum from '../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../Enums/ShownPanelsEnum';
import CountryService from '../Services/CountryService';
import OperationsProjectService from '../Services/OperationsProjectService';
import TabOfDataTable from './DataTable/TabOfDataTable';
import ErrorMessage from './ErrorMessage';
import GeneralEditWizzardBase from './GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import Loading from './loading.js';
import FigmaButtonRow from './FigmaButtonRow';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';

class ClientFeesComponent extends React.Component {
  static defaultProps = {
    serviceId: null,
    projectDetailItem: null,
    selectedCountry: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      logList: [],
      loading: false,
      selectedLogId: -1,
      selected: -1,
      selectedItem: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      searchItem: props.searchItem,
      selectedCountry: '',
      countryOfficePairs: {},
    };

    this.clickOnAddProjectPricingButton = this.clickOnAddProjectPricingButton.bind(this);
    ProjectPricingItem.getServiceNumber = this.getServiceNumber.bind(this);
    this.itemEditedFunction = this.itemEditedFunction.bind(this);
  }

  componentDidMount() {
    CountryService.GetCountriesOffices()
      .then((result) => {
        this.setState({ countryOfficePairs: result });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: DA62');
      });
  }

  getServiceNumber() {
    return this.props.serviceId;
  }

  renderActionButtons() {
    return (
      <FigmaButtonRow
        className={'InnerMenuButtonFigmaList'}
        buttons={[
          {
            label: 'Add New Client Fee',
            tooltip: 'Add New Client Fee',
            onClick: this.clickOnAddProjectPricingButton,
            roleKey: 'project_addnewclientfee',
            color: ButtonColorsEnum.Primary,
          },
        ]}
      />
    );
  }

  clickOnAddProjectPricingButton(selectedId, selectedItem) {
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.AddNewItem,
    });
  }

  createPanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: false,
    });
  }

  savePanelOnClose() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: false,
    });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  itemEditedFunction(editedItem) {
    if (this.state.selectedCountry === editedItem.CountryId) {
      return;
    }
    this.setState({ selectedCountry: editedItem.CountryId });
    if (editedItem.CountryId !== '') {
      const pair = this.state.countryOfficePairs.find(
        (f) => f.CountryId.toString() === editedItem.CountryId.toString()
      );
      if (pair) {
        editedItem.OfficeId = pair.OfficeId;
      }
    }
  }

  render() {
    return (
      <div className='verticalScroll panel-max-height-500'>
        <Loading loading={this.state.loading} />
        {!this.state.loading && (
          <div>
            {this.renderOnePanel(
              ShownPanelsEnum.AddNewItem,
              <GeneralEditWizzardBase
                crudType={CrudTypesEnum.Create}
                editedItem={new ProjectPricingItem()}
                clickOnCancel={this.createPanelOnClose.bind(this)}
                clickOnSave={this.savePanelOnClose.bind(this)}
                windowDescription={AddProjectPricingCreateWindowDescription}
                onChangeEditedItem={this.itemEditedFunction}
                errorCode='CFC131'
              />
            )}
            {this.renderActionButtons()}
            <TabOfDataTable
              type={ClientFeeItem}
              shownPanel={this.state.shownPanel}
              serviceFunction={OperationsProjectService.GetClientFeeList}
              convertDBItemsFunction={OperationsProjectService.ConvertPricingDBItemList}
              searchItem={{ CfServiceId: this.state.searchItem.CfServiceId }}
              orderDirection={OrderDirectionsEnum.Desc}
              showSearchStrip={true}
              errorCode='CDC142'
            />
          </div>
        )}
      </div>
    );
  }
}

export default ClientFeesComponent;
